import React from 'react';
import { useHistory } from 'react-router-dom';
import { getAdminTaskManagerPath, getProcessManagerPath, getProcessManagerReportPath } from '@css-xp/apd-common';

export const useProcessManager = () => {
  const history = useHistory();

  const openRuleManager = React.useCallback(() => {
    history.push(getProcessManagerPath());
  }, []);

  const openAdminTaskManager = React.useCallback(() => {
    history.push(getAdminTaskManagerPath());
  }, []);

  const openReport = React.useCallback(() => {
    history.push(getProcessManagerReportPath());
  }, []);

  return { openRuleManager, openAdminTaskManager, openReport };
};
